module.exports = __webpack_public_path__ + "static/media/nike.94bd06aa.jpeg";